import { handle } from 'redux-pack';
import { Action } from "../../../types/actions";
import { ISocketCommentProps } from '../../../types/working-model';
import { toMap } from '../../../utils/utils';
import { DELETE_CHAT_MESSAGE, INCOMING_CHAT_MESSAGE, LOAD_CHAT_MESSAGES, UNAPPROVE_CHAT_MESSAGE, UNDELETE_CHAT_MESSAGE } from '../../actions/event/chat-actions';

export interface ChatState {
	comments: Map<number, ISocketCommentProps>;
	loadingComments: boolean;
	loadingCommentsError: string;
}

const defaultState: ChatState = {
	comments: new Map(),
	loadingComments: false,
	loadingCommentsError: ""
};

export default function ChatReducer(state: ChatState = defaultState, action: Action): ChatState {
	switch (action.type) {
		case UNDELETE_CHAT_MESSAGE:
		case INCOMING_CHAT_MESSAGE: {
			const comments = new Map(state.comments);
			comments.set(action.payload.id, action.payload);
			return {
				...state,
				comments: comments
			};
		}

		case DELETE_CHAT_MESSAGE:
		case UNAPPROVE_CHAT_MESSAGE: {
			const comments = new Map(state.comments);
			comments.delete(action.payload);
			return {
				...state,
				comments: comments
			};
		}

		case LOAD_CHAT_MESSAGES: {
			return handle(state, action, {
				start: (state) => ({ ...state, loadingComments: true }),
				finish: (state) => ({ ...state, loadingComments: false }),
				failure: (state) => ({ ...state, loadingCommentsError: 'Unable to load chat' }),
				success: (state) => {
					if ('error' in action.payload) {
						return ({
							...state,
							loadingCommentsError: action.payload.error
						});
					} else if ('msg' in action.payload) {
						return ({
							...state,
							loadingCommentsError: action.payload.msg
						});
					} else {
						return {
							...state,
							loadingCommentsError: '',
							comments: toMap('id', action.payload) as Map<number, ISocketCommentProps>
						};
					}
				}
			});
		}

		default: return state;
	}
}